import React from 'react';

import { i18n } from 'config/locales';

import connectSubsection from 'components/Section/shared/SubsectionConnector';
import Subsection from 'components/Section/shared/Subsection';
import { FINANCIAL, FINANCIAL_CHILD_SUPPORT } from 'config/formSections/financial';
import { Summary, DateSummary } from 'components/Summary';
import Branch from 'components/Form/Branch';
import Accordion from 'components/Form/Accordion';
import NotApplicable from 'components/Form/NotApplicable';
import { EmptyListInstance } from 'forms/shared/models';
import { EmptyBranch } from 'forms/shared/validators/models/branch/instance';
import ChildSupportItem from './ChildSupportItem';

const sectionConfig = {
  key: FINANCIAL_CHILD_SUPPORT.key,
  section: FINANCIAL.name,
  store: FINANCIAL.store,
  subsection: FINANCIAL_CHILD_SUPPORT.name,
  storeKey: FINANCIAL_CHILD_SUPPORT.storeKey,
};

export class ChildSupport extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.handleError = this.handleError.bind(this);
  }

  update = (queue) => {
    this.props.onUpdate(this.storeKey, {
      HasChildSupport: this.props.HasChildSupport,
      HasChildSupportNotApplicable: this.props.HasChildSupportNotApplicable,
      List: this.props.List,
      ...queue,
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  updateHasChildSupport = (values) => {
    this.update({
      HasChildSupport: values,
      List: values?.value === 'Yes' ? this.props.List : { items: [], branch: {} },
    });
  };

  updateHasChildSupportNotApplicable = (values) => {
    const isApplicable = values?.applicable;
    this.update({
      HasChildSupportNotApplicable: values,
      HasChildSupport: isApplicable ? this.props.HasChildSupport : EmptyBranch(),
      List: isApplicable ? this.props.List : EmptyListInstance,
    });
  };

  /**
  * Assists in rendering the summary section.
  */
  summary = (item, index) => {
    const b = item.Item || {};
    const from = DateSummary(b.DateFiled);

    return Summary({
      type: i18n.t('financial.pvq.childSupport.collection.summary.item'),
      index,
      left: '',
      right: from,
      placeholder: i18n.t('financial.pvq.childSupport.collection.summary.unknown'),
    });
  };

  render() {
    const {
      errors,
      required,
      scrollIntoView,
      scrollToBottom,
      defaultState,
      dispatch
    } = this.props;

    const accordionErrors = errors && errors.filter((e) => e?.indexOf?.('List.accordion') === 0);

    return (
      <div
        className="section-content childsupport"
        data-section={FINANCIAL.key}
        data-subsection={FINANCIAL_CHILD_SUPPORT.key}
      >
        <h1 className="section-header">{i18n.t('financial.pvq.destination.childsupport')}</h1>
        <NotApplicable
          {...this.props.HasChildSupportNotApplicable}
          label={i18n.t('financial.pvq.shared.na')}
          attribute="HasChildSupportNotApplicable"
          onUpdate={this.updateHasChildSupportNotApplicable}
          scrollIntoView={this.props.scrollIntoView}
          required={this.props.required}
          useChangeWarning
        >
          <Branch
            name="has_childSupport"
            label={i18n.t('financial.pvq.childSupport.branch.title')}
            labelSize="h4"
            className="childsupport-branch"
            {...this.props.HasChildSupport}
            warning
            onUpdate={this.updateHasChildSupport}
            required={required}
            scrollIntoView={scrollIntoView}
            onError={this.handleError}
            attribute="HasChildSupport"
          />
        </NotApplicable>
        {this.props.HasChildSupport?.value === 'Yes' && (
          <Accordion
            {...this.props.List}
            defaultState={defaultState}
            scrollToBottom={scrollToBottom}
            onUpdate={this.updateList}
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            required={required}
            summary={this.summary}
            errors={accordionErrors}
            scrollIntoView={scrollIntoView}
            appendTitle={i18n.t('financial.pvq.childSupport.appendTitle')}
            attribute="List"
          >
            <ChildSupportItem
              name="Item"
              dispatch={dispatch}
              required={required}
              scrollIntoView={scrollIntoView}
              bind
            />
          </Accordion>
        )}
      </div>
    );
  }
}

ChildSupport.defaultProps = {
  onUpdate: () => {},
  onError: (value, arr) => arr,
  dispatch: () => {},
  defaultState: true,
  scrollToBottom: '.bottom-btns',
  errors: [],
};

export default connectSubsection(ChildSupport, sectionConfig);
